import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useUser } from '../auth';
import { isItAccess } from '../constants/Roles';
const PublicRoute = ({ component: Component, ...rest }) => {
	const { isSignedIn, user } = useUser();
	return (
		<Route
			{...rest}
			render={(props) => {
				if (isSignedIn) {
					// IT Access users have no dashboard; send them to User Management.
					return <Redirect to={isItAccess(user) ? '/management' : '/dashboard'} />;
				}
				return <Component {...props} />;
			}}
		/>
	);
};

export default PublicRoute;
